import dayjs from "dayjs";
import { MedicalServices } from "@mui/icons-material";
import { ProcedureRequestActions } from "../../ProcedureRequest/ProcedureRequestActions";
import { DocumentCard } from "../../../../../../components/common/DocumentCard";
import { EhrResponsiveTable } from "../../../mobile/EhrResponsiveTable";

/**
 * Componente para exibir procedimentos médicos do paciente
 * Implementa uma aba dentro do PatientDocs seguindo o mesmo padrão do ProcedureRequest
 */
export function Procedures({
  data,
  resultsData,
  handleOpen,
  setBinaryUrl,
  sign,
  setRefetch,
  procedureServiceRequests,
}: any) {
  const procedureDocuments = data?.filter((el: any) => {
    return !!el?.resource?.content?.[0]?.attachment?.url;
  });

  const columns = [
    {
      column: "Descrição",
      rowName: "description",
    },
    { column: "Data", rowName: "date" },
    { column: "Profissional solicitante", rowName: "practitioner" },
  ];

  const rows =
    procedureDocuments
      ?.map((doc: any, index: number) => {
        const binaryUrl = doc?.resource?.content?.[0]?.attachment?.url || "";

        const serviceRequestId =
          doc?.resource?.basedOn?.[0]?.reference?.split("/")[1];
        let relatedServiceRequest = null;

        if (serviceRequestId && procedureServiceRequests?.[0]?.entry) {
          relatedServiceRequest = procedureServiceRequests[0].entry.find(
            (sr: any) => sr?.resource?.id === serviceRequestId,
          );
        }

        let description = "";

        if (
          relatedServiceRequest?.resource?.code?.concept?.coding?.[0]?.display
        ) {
          description =
            relatedServiceRequest.resource.code.concept.coding[0].display;
        } else if (doc?.resource?.type?.coding?.[0]?.display) {
          description = doc.resource.type.coding[0].display;
        } else if (doc?.resource?.title) {
          description = doc.resource.title;
        } else {
          description = "Procedimento";
        }

        let practitionerName = "-";

        if (doc?.resource?.contained) {
          const practitioner = doc.resource.contained.find(
            (cont: any) => cont.resourceType === "Practitioner",
          );

          if (practitioner?.name?.[0]?.text) {
            practitionerName = practitioner.name[0].text;
          }
        }

        if (
          practitionerName === "-" &&
          relatedServiceRequest?.resource?.contained?.[0]?.name?.[0]?.text
        ) {
          practitionerName =
            relatedServiceRequest.resource.contained[0].name[0].text;
        }

        if (practitionerName !== "-") {
          practitionerName = `Dr(a). ${practitionerName}`;
        }

        const date = relatedServiceRequest?.resource?.authoredOn
          ? dayjs(relatedServiceRequest.resource.authoredOn).format("DD/MM/YYYY")
          : dayjs(doc?.resource?.date).format("DD/MM/YYYY") || "-";

        const encounter = doc?.resource?.context?.encounter?.reference;
        let encounterId = encounter ? encounter.split("/")?.[1] : undefined;

        if (
          !encounterId &&
          relatedServiceRequest?.resource?.encounter?.reference
        ) {
          const encounterRef = relatedServiceRequest.resource.encounter.reference;
          encounterId = encounterRef.split("/")?.[1];
        }

        return {
          id: index,
          description,
          date,
          practitioner: practitionerName,
          binaryUrl,
          encounterId,
          fullResource: doc?.resource,
          fullServiceResource: relatedServiceRequest
            ? [relatedServiceRequest]
            : [],
          status: relatedServiceRequest?.resource?.status || "active",
        };
      })
      ?.filter((row: any) => row.binaryUrl)
      ?.sort((a: any, b: any) => {
        const dateA = dayjs(a.date, "DD/MM/YYYY");
        const dateB = dayjs(b.date, "DD/MM/YYYY");
        return dateB.diff(dateA);
      }) || [];

  return (
    <EhrResponsiveTable
      title="Procedimentos"
      hideSectionHeader
      columns={columns}
      rows={rows}
      actions={(rowData: any) => (
        <ProcedureRequestActions
          row={rowData}
          handleOpen={handleOpen}
          setBinaryUrl={setBinaryUrl}
        />
      )}
      renderCard={(row) => (
        <DocumentCard
          key={row.id ?? row.description}
          title={row.description || "Procedimento"}
          date={row.date}
          practitioner={row.practitioner}
          status={{
            text: "Procedimento",
            color: "#9C27B0",
            icon: <MedicalServices fontSize="small" />,
          }}
          actions={
            <ProcedureRequestActions
              row={row}
              handleOpen={handleOpen}
              setBinaryUrl={setBinaryUrl}
            />
          }
        />
      )}
    />
  );
}
